<!-- ConfirmModal.vue -->
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    default: 'Confirm Action',
  },
  message: {
    type: String,
    default: 'Are you sure you want to proceed?',
  },
  onConfirm: {
    type: Function,
    required: true,
  },
  onCancel: {
    type: Function,
    required: true,
  },
});
</script>

<template>
  <!-- Overlay -->
  <transition name="fade">
    <div
        v-if="show"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        aria-labelledby="confirmModalTitle"
        aria-describedby="confirmModalMessage"
        role="dialog"
        aria-modal="true"
    >
      <!-- Modal Container -->
      <div class="bg-white dark:bg-gray-900 rounded-lg shadow-lg max-w-md w-full mx-4 p-6">
        <!-- Header -->
        <h2
            id="confirmModalTitle"
            class="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-4"
        >
          {{ props.title }}
        </h2>

        <!-- Body (Message) -->
        <p
            id="confirmModalMessage"
            class="text-gray-700 dark:text-gray-300 text-center text-lg mb-6"
        >
          {{ props.message }}
        </p>

        <!-- Footer (Actions) -->
        <div class="flex justify-end space-x-3">
          <button
              class="px-4 py-2 rounded-md bg-gray-300 hover:bg-gray-400 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white transition-all duration-200"
              @click="props.onCancel"
          >
            Cancel
          </button>
          <button
              class="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white dark:bg-blue-500 dark:hover:bg-blue-600 transition-all duration-200"
              @click="props.onConfirm"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
